export const VoidPaymentTransactionModalConstants = {
    CONFIRMATION_DIALOG_TITLE: 'Void Payment',
    CONFIRMATION_DIALOG_CONTENT:
        'Are you sure you want to void this transaction?',
    PRIMARY_ACTION_TITLE: 'Void Payment',
    SUCCESS_MESSAGE: 'Payment has been successfully voided.',
} as const;

export const CreditPaymentTransactionModalConstants = {
    SUCCESS_MESSAGE: 'Payment has been successfully credited.',
} as const;

export const ConfirmPaymentTransactionModalConstants = {
    SUCCESS_MESSAGE: 'Payment has been successfully confirmed.',
} as const;

export const SendInvoiceModalConstants = {
    SEND_TITLE: 'Send Invoice',
    RESEND_TITLE: 'Resend Invoice',
    SEND_CONTENT:
        'You have not yet sent an invoice for this order. Clicking confirm below will send an invoice to the customer.',
    RESEND_CONTENT:
        'You already sent an invoice for this order. Clicking confirm below will send a new invoice to the customer.',
    PRIMARY_ACTION_TITLE: 'Confirm',
    SUCCESS_MESSAGE: 'Invoice has been successfully sent.',
} as const;
